import { BrowserRouter, useRoutes } from 'react-router-dom';
import routes from '@/router';
import RouterGuard from '@/router/RouterGuard';
import { RecoilRoot } from 'recoil';
// Ant Design 5.x不需要手动导入CSS
import './App.css';
import React from 'react';

const AppRoutes = React.memo(() => {
    const element = useRoutes(routes);
    return element;
});
function App() {
    return (
        <RecoilRoot>
            <BrowserRouter>
                <RouterGuard>
                    <AppRoutes />
                </RouterGuard>
            </BrowserRouter>
        </RecoilRoot>
    );
}

export default App;
